import { render } from "./brandList.vue?vue&type=template&id=1724ccdc&scoped=true"
const script = {}

import "./brandList.vue?vue&type=style&index=0&id=1724ccdc&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1724ccdc"]])

export default __exports__